import React, { useState } from 'react';

type Locale = 'hr' | 'en';
const INK = '#1f2333';

/** HRMS gornji header — zamjena za zlatni topbar kad je app_theme='hrms'. Full-width, sticky. */
export function HrmsHeader({ locale, title, lead, user, vpnBadge, onOpenProfile, onLogout, onOpenKiosk, onLocaleChange }: {
    locale: Locale;
    title: string;
    lead?: string;
    user: { name?: string; email?: string; role?: string };
    vpnBadge?: boolean;
    onOpenProfile: () => void;
    onLogout: () => void;
    onOpenKiosk: () => void;
    onLocaleChange: (l: Locale) => void;
}) {
    const [menu, setMenu] = useState(false);
    const t = (hr: string, en: string) => (locale === 'en' ? en : hr);
    const initial = (user.name || user.email || '?').slice(0, 1).toUpperCase();

    return (
        <header className="hrms-header">
            <div style={{ minWidth: 0, flex: 1 }}>
                <h1 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 800, color: INK, lineHeight: 1.15, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</h1>
                {lead ? <div style={{ fontSize: '0.8rem', color: '#8a90a6', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{lead}</div> : null}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <button type="button" onClick={onOpenKiosk} className="hrms-header-clock">{t('Evidencija rada', 'Time clock')}</button>
                {vpnBadge ? <span className="hrms-vpn-badge">VPN</span> : null}

                <div style={{ position: 'relative' }}>
                    <button type="button" onClick={() => setMenu((m) => !m)} className="hrms-header-profile">
                        <span className="hrms-header-avatar">{initial}</span>
                        <span style={{ textAlign: 'left', minWidth: 0 }}>
                            <span style={{ display: 'block', fontSize: '0.82rem', fontWeight: 700, color: INK, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 140 }}>{user.name || user.email}</span>
                            <span style={{ display: 'block', fontSize: '0.7rem', color: '#8a90a6' }}>{user.role || ''}</span>
                        </span>
                        <span style={{ color: '#9aa0b4', fontSize: '0.7rem' }}>▼</span>
                    </button>
                    {menu ? (
                        <>
                            <div onClick={() => setMenu(false)} style={{ position: 'fixed', inset: 0, zIndex: 70 }} />
                            <div className="hrms-header-menu">
                                <button type="button" onClick={() => { setMenu(false); onOpenProfile(); }}>{t('Uredi profil', 'Edit profile')}</button>
                                <button type="button" onClick={() => onLocaleChange(locale === 'en' ? 'hr' : 'en')}>{locale === 'en' ? 'Hrvatski' : 'English'}</button>
                                <button type="button" onClick={() => { setMenu(false); onLogout(); }} style={{ color: '#a32020' }}>{t('Odjava', 'Logout')}</button>
                            </div>
                        </>
                    ) : null}
                </div>
            </div>
        </header>
    );
}
